const apiCache = new Map<string, { data: any; expiry: number }>()

export const cachedApiCall = async <T>(
  key: string,
  apiCall: () => Promise<T>,
  ttl: number = 5 * 60 * 1000
): Promise<T> => {
  const now = Date.now()
  const cached = apiCache.get(key)

  if (cached && cached.expiry > now) {
    return cached.data
  }

  const result = await apiCall()
  apiCache.set(key, { data: result, expiry: now + ttl })

  return result
}

/**
 * Drops every memoised response.
 *
 * Called when the connection returns: SWR revalidates on reconnect, but its
 * fetchers run through this memo, so without clearing it a post-outage
 * revalidation is served the pre-outage response for up to the full TTL and
 * nothing actually refreshes.
 *
 * Only successful responses are cached, so this discards good entries and
 * costs at most one refetch per live key.
 */
export const clearCachedApiCall = () => {
  apiCache.clear()
}
